export default __webpack_public_path__ + "static/media/UserRfpReportLightActive.23358baa.svg";